import axios from "../../axios";

const urlPillars = "/pillars";
const urlPillarsDeleteMultiple = "/pillars/delete-multiple";

const state = {
  pillars: [],
  pillar: {},
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * getListpillars
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListPillars({ commit }, query) {
    const response = await axios.get(
      `${urlPillars}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_PILLARS", response.data.data);
    }

    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async getDetailPillar({ commit }, { id, payload }) {
    const response = await axios.get(
      `${urlPillars}/${id}?${new URLSearchParams(payload)}`,
    );
    if (response.status === 200) {
      console.log("SET_PILLARS");
      console.log(response.data.data);

      commit("SET_PILLARS", response.data.data);
    }

    return response;

    // return new Promise((resolve, reject) => {
    //   axios.get(`${urlPillars}/${id}?${new URLSearchParams(payload)}`)
    //     .then((response) => {
    //       resolve(response.data ?? {})
    //     })
    //     .catch((error) => { reject(error) })
    // })
  },

  /**
   * createPillars
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createPillars({ commit }, payload) {
    return await axios.post(urlPillars, payload);
  },

  /**
   * updateTeam
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updatePillars({ commit }, { id, payload }) {
    return await axios.put(`${urlPillars}/${id}`, payload);
  },

  /**
   * deleteTeam
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deletePillars({ commit }, id) {
    return await axios.delete(`${urlPillars}/${id}`);
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlPillarsDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_PILLARS(state, data) {
    if (data) {
      state.pillars = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },

  SET_PILLARS(state, data) {
    state.pillar = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
